
import { SubClassDTO, ResultsDTO } from "Types";
import { ApiService } from "Services/ApiService";


export const SubClassControllerApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getListOfSubCategories: builder.query<SubClassDTO[], void>({
      query: () => ({
        url: `/subclass`,
        method: "GET",
        headers: {
          origin: "*",
        },
      }),
      transformResponse: (response: ResultsDTO<SubClassDTO[]>) =>
        response.results ?? [],
    }),
  }),
});

export const { useGetListOfSubCategoriesQuery } = SubClassControllerApiSlice;
